/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from "react";
import CommentIcon from "../../../../../assets/images/comment-dots.svg";
import CommentIconVisible from "../../../../../assets/images/commen-visible-icon.svg";
import { Tooltip } from "@material-ui/core";

const CustomCommentComponent = (props) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Tooltip title="Comment">
        <img
          alt="comment"
          src={
            props.data && props.data.corrLinkId
              ? CommentIconVisible
              : CommentIcon
          }
          style={{ cursor: "pointer" }}
        />
      </Tooltip>
    </div>
  );
};

export default CustomCommentComponent;
